module.exports = __webpack_public_path__ + "img/bcc346.3e5174f3.jpeg";